import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';


export enum ModuleHeader{
  STREAMS='Streams',
  BROKEN_STREAMS='Broken Streams',
  SEASON_TICKETS='Season Tickets',
  ADS='Manage Ads',
  REPORTS='Reports',
  USERS='Joymoicans',
  CHANNELS='Channels',
  EVENTS='Events',
  PAGES='Pages',
  NAMEDTAGS='Namedtags',
}
export interface BreadCrumbs{
  name: string| ModuleHeader,
  url?: string,
  type?: 'EVENT' | 'NAMEDTAG' | 'STREAM' | 'PAGE' | 'ATTRIBUTE'
}
@Injectable({
  providedIn: 'root',
})
export class BreadCrumbsService {
  private breadCrumbValues: BreadCrumbs[] = [];
  private readonly breadCrumbs = new BehaviorSubject<BreadCrumbs[]>(
    this.breadCrumbValues,
  );
  public share = this.breadCrumbs.asObservable();
  private readonly callFunction = new Subject<ModuleHeader | {
    moduleHeader: ModuleHeader;
    name: string;
}>();

  resetBreadCrumbs() {
    this.breadCrumbValues = [];
    this.breadCrumbs.next(this.breadCrumbValues);
  }
  setBreadCrumbs(breadCrumbs: BreadCrumbs) {
    this.breadCrumbValues.push(breadCrumbs);
    this.breadCrumbs.next(this.breadCrumbValues);
  }
  popBreadCrumb() {
    this.breadCrumbValues.pop();
    this.breadCrumbs.next(this.breadCrumbValues);
  }
  sendClickEvent(moduleHeader: ModuleHeader, name?: string) {
    let obj;
    if (name) {
      obj = {
        moduleHeader: moduleHeader,
        name: name,
      };
    } else {
      obj = moduleHeader;
    }
    this.callFunction.next(obj);
  }
  getClickEvent() {
    return this.callFunction.asObservable();
  }
}
